import image1 from '../images/memberships/Enmascarar grupo 7.png';
import image2 from '../images/memberships/Enmascarar grupo 6.png';

import first from '../images/memberships/first.png';
import diamond from '../images/memberships/diamond.png';

const memberships = [
	{
		id: 0,
		image: image1,
		icon: first,
		title: 'Acceso CYBORG',
		price: '149',
		price_before: '249',
		items: [
			{
				item: 'Acceso al curso Cyborg',
				more: 'Tendrás acceso únicamente al contenido del curso Cyborg.',
			},
			// {
			//     item: "Acceso a feedback en vivo y materiales.",
			//     more: "Podrás acceder sin problema a los feedback en vivo y tendrás acompañamiento del maestro.",
			// },
			{
				item: 'Acceso por un año al contenido.',
				more: 'Tendrás un año de acceso al contenido del curso Cyborg',
			},
			{ item: 'Acceso a Discord Privado', more: null },
		],
		urls: [
			{
				name: 'Pagar con PayPal',
				url: 'https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=9AL3YEVZHK4XN',
			},
			{
				name: 'Pagar con Tarjeta',
				url: 'https://payco.link/1244468',
			},
		],
	},
	{
		id: 1,
		image: image2,
		icon: diamond,
		title: 'Acceso TOTAL',
		price: '199',
		price_before: '399',
		items: [
			{
				item: 'Acceso a todos los entrenamientos',
				more: 'Tendrás a tu disposición todo el contenido de la Escuela ZBrush',
			},
			// {
			//     item: "Acceso a feedback en vivo y materiales.",
			//     more: "Podrás acceder sin problema a los feedback en vivo y tendrás acompañamiento del maestro.",
			// },
			{
				item: 'Acceso por un año al contenido.',
				more: 'El año de acceso se empieza a contar a partir de la activación del contenido en tu cuenta..',
			},
			{ item: 'Acceso a Discord privado', more: null },
		],
		urls: [
			{
				name: 'Pagar con PayPal',
				url: 'https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=D34KUCZNAG4TJ',
			},
			{
				name: 'Pagar con Tarjeta',
				url: 'https://payco.link/1244471',
			},
		],
	},
];

export default memberships;
